module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textfield",
    class: {
      'single-line': _vm.singleLine
    },
    style: ((_vm.config.newline && (_vm.mappedData !== '')) ? 'margin-top: 8px' : '')
  }, [(!_vm.isUrlField) ? [(_vm.config.style === 'strong') ? _c('strong', [_vm._v(" " + _vm._s(_vm.mappedData) + " ")]) : (_vm.config.style === 'italics') ? _c('i', [_vm._v(" " + _vm._s(_vm.mappedData) + " ")]) : [_vm._v("\n      " + _vm._s(_vm.mappedData) + "\n    ")]] : [_c('a', {
    attrs: {
      "href": _vm.mappedData,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.config.label))])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a23901ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldText.vue
// module id = 712
// module chunks = 0